import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

import hu from 'vuetify/es5/locale/hu'

Vue.component('my-component', {
  methods: {
    changeLocale () {
      this.$vuetify.lang.current = 'hu'
    },
  },
})

export default new Vuetify({
  lang: {
  locales: { hu },
  current: 'hu',
  },
  icons: {
    iconfont: 'mdi',
  },
  theme: {
  themes: {
    light: {
      primary: '#FF9800',
      // secondary: '#b0bec5',
      // accent: '#8c9eff',
      // error: '#b71c1c',
    },
  },
},
});
